<template>
  <div
    class="  w-full border-l-4 border-l-blue-600 flex flex-row bg-gray-100  rounded-sm border-t border-b border-r border-t-gray-300 border-b-gray-300 border-r-gray-300 ">
    <div class="w-96 flex items-center px-2 text-left truncate   ">
      <p class="truncate">
        {{ output.name }}
      </p>
    </div>
    <div v-if="(output.type=='string')   " class=" flex flex-row justify-start text-left w-full  bg-red-100 ">
      <div class="  py-2 mr-2 w-64  bg-green-100">
        <select v-model="output.action" class="form-control  rounded-sm py-1 border border-gray-300 px-2"
          @change="onChangeAction">
          <option v-for="operator in operators_string" :key="operator.id" :value="operator.id">
            {{operator.name}}  
          </option>
        </select>
      </div>
      <div class="w-full py-2 flex flex-row justify-start text-left" v-if="output.action  != 'is-empty'">
        <input v-model="output.value" type="text"
          class="max-w-48 form-control    rounded-sm py-1 px-2 border border-gray-300">
      </div>
    </div>


    <div v-if="(output.type=='number')   " class="flex flex-row w-full justify-start text-left  ">
      <div class="w-full py-2 mr-2">
        <select v-model="output.action" class="form-control  rounded-sm py-1 border border-gray-300 px-2"
          @change="onChangeAction">
          <option v-for="operator in operators_number" :key="operator.id" :value="operator.id">
            {{operator.name}}
          </option>
        </select>
      </div>
      <div class="w-full py-2">
        <input v-model="output.value" type="text"
          class="w-36 form-control    rounded-sm py-1 px-2 border border-gray-300">
      </div>
    </div>


    <div v-if="(output.type=='list')   " class="flex flex-row w-full   text-left justify-start text-left  bg-red-100 ">
      <div class=" py-2 mr-2 w-64  bg-green-100">
        <select v-model="output.action" class="form-control  rounded-sm py-1 border border-gray-300 px-2"
          @change="onChangeAction">
          <option v-for="operator in operators_string" :key="operator.id" :value="operator.id">
            {{operator.name}}
          </option>
        </select>
      </div>
      <div class="w-full py-2 flex flex-row justify-start text-left">
        <select v-model="output.value" class="form-control  rounded-sm py-1 border border-gray-300 px-2 w-full max-w-48" 
          @change="onChangeValue">
          <option v-for="value in output.values" :key="value.id" :value="value.id">
            {{value.name}}
          </option>
        </select>
      </div>
      
    </div> 

    <div v-if="output.type=='list2'" class="flex flex-row w-full d">
      <div class="flex items-center  justify-start w-full py-2 mr-2">
        <input id="bordered-radio-1" type="radio" value="" name="bordered-radio"
          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500">
        <label for="bordered-radio-1"
          class="w-full py-2 text-sm font-medium text-gray-900  text-left ms-2">Default radio</label>
      </div>
      <div class="flex items-center justify-start w-full py-2 mr-2">
        <input id="bordered-radio-2" checked type="radio" value="" name="bordered-radio"
          class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500">
        <label for="bordered-radio-2"
          class="w-full py-2   text-sm font-medium text-gray-900  text-left ms-2">Checked
          state</label>
      </div>
    </div>

    <div class="w-24    flex items-center text-left justify-center cursor-pointer bg-gray-500 text-white"
      @click="onDeleteRow">
      x
    </div>
  </div>
</template>


<script>
 
  export default {
    name: 'QueryBuilderRow',
    components: {},
    props: {
      index: Number,
      inputValue: Object
    },
    data: function () {
      return {
        output: {},
        operators_string: [
          {
            "id": "equals",
            "name": "equals",
            "show_parameter": true
          },
          {
            "id": "does-not-equal",
            "name": "does not equal",
            "show_parameter": true
          },
          {
            "id": "contains",
            "name": "contains",
            "show_parameter": true
          },
          {
            "id": "does-not-contain",
            "name": "does not contain",
            "show_parameter": true
          },
          {
            "id": "is-empty",
            "name": "is empty",
            "show_parameter": false
          },
          {
            "id": "is-not-empty",
            "name": "is not empty",
            "show_parameter": false
          },
          {
            "id": "begins-with",
            "name": "begins with",
            "show_parameter": true
          },
          {
            "id": "ends-with",
            "name": "ends with",
            "show_parameter": true
          }
        ]
        ,
        operators_list: [
          {
            "id": "equals",
            "name": "equals",
            "show_parameter": true
          },
          {
            "id": "does-not-equal",
            "name": "does not equal",
            "show_parameter": true
          },
          {
            "id": "is-empty",
            "name": "is empty",
            "show_parameter": false
          },
          {
            "id": "is-not-empty",
            "name": "is not empty",
            "show_parameter": false
          } 
        ],
        operators_number: [
          {
            "id": "equals",
            "name": "equals",
            "show_parameter": true
          },
          {
            "id": "does-not-equal",
            "name": "does not equal",
            "show_parameter": true
          },
          {
            "id": "contains",
            "name": "contains",
            "show_parameter": true
          },
          {
            "id": "does-not-contain",
            "name": "does not contain",
            "show_parameter": true
          },
          {
            "id": "is-empty",
            "name": "is empty",
            "show_parameter": false
          },
          {
            "id": "is-not-empty",
            "name": "is not empty",
            "show_parameter": false
          },
          {
            "id": "begins-with",
            "name": "begins with",
            "show_parameter": true
          },
          {
            "id": "ends-with",
            "name": "ends with",
            "show_parameter": true
          }
        ]
      }

    },
    
    computed:
    {
      findValues : function()
      {
        return [
              {
                "id": "free", "name": "Free"
              },
              {
                "id": "premium", "name": "Premium"
              }
            ]
      }
    },
    
    watch:
    {
      inputValue: function () {
        this.output = this.inputValue
      }
    },
    async mounted() {
      this.output = this.inputValue

    },
    methods:
    {
      onChangeAction() {
        this.$emit("updateRow", this.output)
      },
      onDeleteRow() {
        this.output.index = this.index
       // console.log("QueryBuilderRow", "onDeleteRow")
        this.$emit("deleteRow", this.output)
      }
    }

  }
</script>